import { ErrorMessage, GoogleFontIcon } from '@asset-metrix/portal-ui';
import clsx from 'clsx';
import { TFunction } from 'i18next';

import { FilterConfigDto } from '../../store/states/filterTypes';

import { Filter } from './Filter';

import styles from './filters.module.scss';

export type FiltersComponentProps = {
  className?: string;
  config: { filters?: FilterConfigDto[] };
  isFetching: boolean;
  entityId: string;
  resetFilterSelection: (pageId: string) => void;
  error: Error | null;
  translate: TFunction<'translation', undefined>;
  embedded?: boolean;
};

export function FiltersComponent({
  className,
  config: { filters = [] },
  isFetching,
  entityId,
  resetFilterSelection,
  error,
  translate,
  embedded = false,
}: FiltersComponentProps) {
  const showResetIcon = filters.some(
    (configDto) => configDto.requiresSelection !== true
  );

  const content = (
    <>
      {filters.map((configDto, index) => {
        return (
          <div className={styles['pagefilter__wrapper']} key={configDto.key}>
            <div
              className={clsx(
                styles['pagefilter__filter'],
                configDto.display === 'range-date-picker' &&
                  styles['pagefilter__filter-range']
              )}
            >
              <Filter
                isFetching={isFetching}
                filterConfig={configDto}
                entityId={entityId}
                key={index}
              />
            </div>
            {index + 1 === filters.length && showResetIcon && (
              <GoogleFontIcon
                title={translate('app.pageFilter.reset')}
                onClick={() => resetFilterSelection(entityId)}
                solid={true}
                className={styles['resetIcon']}
                name="filter_alt_off"
              />
            )}
          </div>
        );
      })}
      {error != null && (
        <div>
          <ErrorMessage>{error.message}</ErrorMessage>
        </div>
      )}
    </>
  );

  return embedded ? (
    content
  ) : (
    <div className={clsx(styles['container'], className)}>{content}</div>
  );
}
